<template>
  <div
    :class="{
      'accordion-item-fi': true,
      'accordion-item-fi--active': isOpen,
      'accordion-item-fi--item-list': isItemListTheme,
      'accordion-item-fi--content-background-dark': isContentBackgroundDark,
      [`accordion-item-fi--theme-${theme}`]: theme,
    }"
  >
    <div
      ref="accordionItemHeader"
      class="accordion-item-fi__header"
      @click="onHeaderClick"
    >
      <component
        :is="headerTag"
        :class="{
          'accordion-item-fi__header__text': !isItemListTheme,
          'accordion-item-fi__header__content': isItemListTheme,
        }"
      >
        <slot name="header" />
      </component>
      <div class="accordion-item-fi__toggle">
        <div
          :class="{
            'accordion-item-fi__toggle-icon': true,
            'accordion-item-fi__toggle-icon--active': isOpen,
            'accordion-item-fi__toggle-icon--item-list': isItemListTheme,
          }"
        >
          <icon-fi icon="chevron-down" />
        </div>
      </div>
    </div>

    <slide-up-down-fi
      :model-value="isOpen"
      :duration="700"
      class="accordion-item-fi__slide-up-down"
    >
      <div class="accordion-item-fi__content">
        <slot
          name="content"
          :is-open="isOpen"
        />
      </div>
    </slide-up-down-fi>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import IconFi from '@/components/atoms/icon-fi/IconFi.vue';
import SlideUpDownFi from '@/components/atoms/slide-up-down-fi/SlideUpDownFi.vue';
import { useAccordionItem } from '@/composables/accordionItem';

defineOptions({
  name: 'AccordionItemFi',
});

const props = withDefaults(
  defineProps<{
    headerTag?: string | null;
    theme?: string | null;
    ignoreOthers?: boolean;
    scrollTo?: boolean;
  }>(),
  {
    headerTag: 'div',
    theme: null,
  },
);

const emits = defineEmits<{
  'accordion-item-toggle': [value: boolean];
}>();

const { isOpen, toggleAccordion } = useAccordionItem(props, emits);

const isItemListTheme = computed(() => props.theme === 'item-list');
const isContentBackgroundDark = computed(() => props.theme === 'content-background-dark');

const onHeaderClick = () => {
  toggleAccordion();
};

defineExpose({
  isOpen,
  toggleAccordion,
});
</script>

<style scoped src="./accordion-item-fi" />
